import React, { useContext, useState } from 'react';
import { Box, Typography, Paper, Avatar, Grid2, Tooltip } from '@mui/material';
import { motion } from 'framer-motion';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import BasicDetailsModal, { CompanyAddress, FormValues } from '../Forms/BasicForms';
import { MePUtBAsic } from '../../../../../services/api/Vendorpage/me';
import userContext from '../../../../../configs/context/context';
import ProfileModalResponse from '../../Vendor-ui/profilemodal';
import { REACT_APP_API_IMG } from '../../../../../utlis';

interface propsBasic {
	slug?: string;
	Vendorme?: any;
}

export default function BasicDetailsCard({ slug, Vendorme }: propsBasic) {
	console.log(slug);
	const [basicModal, setBasicModal] = useState(false);
	const { setVendorme } = useContext<any>(userContext);
	const [responseModal, setResponseModal] = useState<any>({
		open: false,
		isSuccess: false,
		message: '',
		responseData: '',
	});
	const OpenModal = () => {
		setBasicModal(true);
	};
	const CloseModal = () => {
		setBasicModal(false);
	};

	const handleSubmit = async (values: FormValues, { setSubmitting, resetForm }: any) => {
		try {
			const formData = new FormData();
			if (values.profilePhoto) {
				formData.append('profilePhoto', values.profilePhoto);
			}

			const companyAddress: CompanyAddress = {
				address: values.address,
				city: values.city,
				state: values.state,
				country: values.country,
				zipCode: values.zipCode,
			};
			formData.append('companyAddress', JSON.stringify(companyAddress));

			const response = await MePUtBAsic(`vendors/${slug}/me`, formData);
			if (response.success) {
				setVendorme((prev: any) => (prev._id == response.data._id ? response?.data : null));
				setResponseModal({
					open: true,
					isSuccess: true,
					message: 'Profile updated successfully!',
					responseData: null,
				});
				resetForm();
				// setPreview(null);
				CloseModal();
			} else {
				// setPreview(null);
				CloseModal();
				setResponseModal({
					open: true,
					isSuccess: false,
					message: 'Profile updated successfully!',
					responseData: null,
				});
			}
		} catch (error: any) {
			// setErrorMessage(error?.response?.data?.message || 'Something went wrong!');
			// setErrorOpen(true);
		} finally {
			setSubmitting(false);
		}
	};
	return (
		<>
			<Paper
				component={motion.div}
				initial={{ opacity: 0, scale: 0.9 }}
				animate={{ opacity: 1, scale: 1 }}
				transition={{ duration: 0.5 }}
				sx={{
					borderRadius: 2,
					boxShadow: '0px 4px 4px rgba(0,0,0,0.1)',
					border: '1px solid #e5e5e5',
					overflow: 'hidden',
					position: 'relative',
					bgcolor: 'white',
				}}
			>
				{/* Header */}
				<Box
					sx={{
						bgcolor: '#1B663C',
						p: 1,
						px: 3,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
					}}
					component={motion.div}
					initial={{ y: -50 }}
					animate={{ y: 0 }}
					transition={{ duration: 0.4 }}
				>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
						<PersonOutlineOutlinedIcon sx={{ color: 'white' }} />
						<Typography
							variant="h6"
							fontWeight={500}
							color="white"
							fontFamily="Poppins"
							sx={{ alignItems: 'center', fontSize: { xs: 14, sm: 16, md: 18 } }}
						>
							Basic Details
						</Typography>
					</Box>
					<Box onClick={() => OpenModal()}>
						<DriveFileRenameOutlineIcon sx={{ color: 'white' }} />
					</Box>
				</Box>

				{/* Content */}
				<Box sx={{ p: { xs: 2, md: 3 } }}>
					<Grid2 container spacing={3}>
						{/* Right Column (Logo / Profile Image) */}
						<Grid2
							size={{ xs: 12, md: 4 }}
							sx={{
								display: 'flex',
								justifyContent: { xs: 'flex-start', md: 'center' },
								alignItems: 'center',
							}}
						>
							<Paper
								component={motion.div}
								whileHover={{ scale: 1.05 }}
								sx={{
									width: 224,
									height: 128,
									border: '2px dotted #9e9e9e',
									borderRadius: 2,
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									justifyContent: 'center',
									// mt: { xs: 1, md: 3 },
									boxShadow: 'none',
								}}
							>
								<Avatar
									src={`${REACT_APP_API_IMG}${Vendorme?.logo}`}
									alt="Profile.jpg"
									sx={{
										width: 64,
										height: 64,
										bgcolor: 'grey.200',
										mb: 1,
									}}
								/>
								<Typography
									variant="body2"
									color="text.secondary"
									noWrap
									sx={{ maxWidth: '90%' }}
								>
									Profile.jpg
								</Typography>
							</Paper>
						</Grid2>
						{/* Left Column */}
						<Grid2 size={{ xs: 12, md: 12 }}>
							<Grid2 container spacing={2}>
								{[
									{
										label: 'Company Name',
										value: Vendorme?.companyName,
									},
									{
										label: 'Email',
										value: Vendorme?.email,
									},
									{
										label: 'Type of Industry',
										value: Vendorme?.companyType,
									},
									{
										label: 'Owner Name',
										value: Vendorme?.ownerName,
									},
									{
										label: 'Company Address',
										value: `${Vendorme?.companyAddress?.address || ''}, ${Vendorme?.companyAddress?.city || ''}, ${Vendorme?.companyAddress?.state || ''}, ${Vendorme?.companyAddress?.country || ''}`,
									},
								].map((item, i) => (
									<Grid2 size={{ xs: 12, sm: 6 }} key={i}>
										<Box>
											<Typography
												color="text.secondary"
												variant="subtitle2"
												fontWeight={500}
											>
												{item.label}
											</Typography>
											<Tooltip title={item.value || ''} arrow>
												<Typography
													variant="body1"
													color="text.primary"
													noWrap
													sx={{
														maxWidth: '100%',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														mb: 1,
													}}
												>
													{item.value || '-'}
												</Typography>
											</Tooltip>
										</Box>
									</Grid2>
								))}
							</Grid2>
						</Grid2>
					</Grid2>
				</Box>
			</Paper>
			{basicModal && (
				<BasicDetailsModal
					openModal={basicModal}
					CloseModal={CloseModal}
					Vendorme={Vendorme}
					handleSubmit={handleSubmit}
				/>
			)}
			<ProfileModalResponse
				open={responseModal.open}
				onClose={() => setResponseModal((prev: any) => ({ ...prev, open: false }))}
				isSuccess={responseModal.isSuccess}
				successMessage={responseModal.message}
				errorMessage={responseModal.message}
				responseData={responseModal.responseData}
			/>
		</>
	);
}
